import React from 'react';

import classes from 'classnames';

import Icon from '../../Icon';
import RightFill from '../../Icon/icons/RightFill';
import s from './index.module.css';

function ColumnHeaderCell({ column }) {
  const { isSorted, isSortedDesc } = column;
  const iconClasses = isSorted ? (isSortedDesc ? s.iconRotateDown : s.iconRotateUp) : '';

  return (
    <>
      <span className={s.title}>{column.render('Header')}</span>
      {column.canSort && <Icon component={RightFill} className={classes(s.icon, iconClasses)} width="4" height="8" />}
    </>
  );
}

export default ColumnHeaderCell;
